import React from 'react';

const Hero = () => {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      const offset = 60; // Stop 60px higher
      const elementPosition = pricingSection.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - offset;
      
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <section className="flex items-center bg-white text-slate-900 relative overflow-hidden pt-24 md:pt-32" id="hero">
      <div className="max-w-7xl mx-auto px-8 grid grid-cols-1 md:grid-cols-2 gap-8 items-stretch relative z-10" style={{ gridTemplateRows: '1fr' }}>
        {/* Left Content */}
        <div className="relative z-10 border-2 border-gray-200 rounded-xl px-6 py-8 flex flex-col justify-center">
          <div className="hidden sm:inline-block bg-green-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-6 w-fit">
            <i className="fa-solid fa-shield-halved mr-1" aria-hidden="true"></i>AI-Powered Scam Protection
          </div>

          <h1 className="font-['Poppins'] text-3xl sm:text-12xl lg:text-12xl font-bold text-slate-900 leading-tight mb-2 sm:mb-6">
            Protect Your Loved Ones from Phone Scams Stress-Free
          </h1>

          <p className="text-lg sm:text-xl text-gray-600 mb-8 leading-relaxed">
            CallSafe uses AI-driven training calls to teach seniors how to
            recognize scams and confidently hang up.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row mb-4">
            <button onClick={scrollToPricing} className="group bg-green-500 text-white px-4 py-2 rounded-full font-bold text-lg hover:bg-green-600 transition-all transform hover:scale-105 text-center mx-4 sm:mx-0">
              Get Protected Today
              <i className="fa-solid fa-arrow-right ml-2 group-hover:translate-x-1 transition-transform" aria-hidden="true"></i>
            </button>
          </div>
        </div>

        {/* Right Image */}
        <div className="relative sm:px-4 flex items-center justify-center">
          <div className="relative rounded-2xl overflow-hidden">
            <img src="https://imagedelivery.net/xaKlCos5cTg_1RWzIu_h-A/669d61e8-2783-43ba-33d9-80d8e2796900/publicContain" alt="Happy patient and caregiver spending time together. Senior woman holding cane." className="w-full h-auto" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
